import App from '../application.js'

import './setup_i18n'
import 'jquery-validation/dist/localization/messages_lv.js'
import '../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.lv.js'
import 'moment/locale/lv.js'
import './translations.tc.lv.js'

$.fn.datepicker.defaults.language = 'lv'

I18n.defaultLocale = 'lv'
I18n.locale = 'lv'

export default App
